import React from 'react';
import { Navigate, type RouteObject } from 'react-router';
import ContainerWrapper from 'pages/SupplyChain/ContainerWrapper';
import { fullPageHeight } from 'utils';

const Dashboard = React.lazy(() => import('pages/SupplyChain/index'));
const SelfAssessmentPage = React.lazy(() => import('pages/SupplyChain/Dashboard/SelfAssessment'));

const SupplierProfileOverview = React.lazy(() => import('pages/SupplyChain/SupplierProfile'));

const SupplierQuestionnaireDetails = React.lazy(() => import('pages/SupplyChain/SupplierProfile/Questionnaires/Details'));
const QuestionnaireResults = React.lazy(() => import('pages/SupplyChain/QuestionnaireResponses/Details'));

const ActionDetails = React.lazy(() => import('pages/SupplyChain/Actions/DetailsPage'));
const ComplaintDetails = React.lazy(() => import('pages/SupplyChain/Complaints/DetailsPage'));
const CaseDetails = React.lazy(() => import('pages/SupplyChain/Cases/DetailsPage'));

const _ROUTE_PATH_SC_DASHBOARD = '/supplychain';
export const getRouteNavSupplyChain = (activeTab = 'overview') => `${_ROUTE_PATH_SC_DASHBOARD}/${activeTab}`;
export const getRouteNavSupplier = (supplierId: string | number, activeTab = 'overview') =>
   `${_ROUTE_PATH_SC_DASHBOARD}/suppliers/${supplierId}/${activeTab}`;

export const ROUTE_KEYS = {
   SUPPLY_CHAIN: 'supplychain',
   OVERVIEW: 'overview',
   OWN_BUSINESS_AREA: 'own-business-area',
   SUPPLIERS: 'suppliers',
   RISK_MAP: 'risk-map',
   NEWS: 'news',
   COMPLAINTS: 'complaints',
   CASES: 'cases',
   ACTIONS: 'actions',
   QUESTIONNAIRES: 'questionnaires',
   DOCUMENTS: 'documents',
} as const;

export const SUPPLIER_ROUTE_KEYS = {
   OVERVIEW: 'overview',
   MASTER_DATA: 'master-data',
   RISKS: 'risk-evaluation',
   COMPLAINTS: 'complaints',
   CASES: 'cases',
   ACTIONS: 'actions',
   EMISSIONS: 'emissions',
   NEWS: 'news',
   QUESTIONNAIRES: 'questionnaires',
   DOCUMENTS: 'documents',
} as const;

export const SELF_ASSESSMENT_SUB_TAB_KEYS = {
   OVERVIEW: 'overview',
   RISK_EVALUATION: 'risk-evaluation',
   DUE_DILIGENCE: 'due-diligence',
   COMPLAINTS: 'complaints',
   CASES: 'cases',
   ACTIONS: 'actions',
   DOCUMENTS: 'documents',
} as const;

const SupplyChainRedirect = () => <Navigate replace to={`${ROUTE_KEYS.OVERVIEW}`} />;
const SupplyChainDocumentHubRedirect = () => <Navigate replace to="all" />;

const SupplierRedirect = () => <Navigate replace to={`${ROUTE_KEYS.OVERVIEW}`} />;
const SupplierDocumentHubRedirect = () => <Navigate replace to="all" />;

const routes: Array<RouteObject> = [
   { path: `${ROUTE_KEYS.SUPPLY_CHAIN}`, element: <SupplyChainRedirect /> },
   { path: `${ROUTE_KEYS.SUPPLY_CHAIN}/${ROUTE_KEYS.DOCUMENTS}`, element: <SupplyChainDocumentHubRedirect /> },
   { path: `${ROUTE_KEYS.SUPPLY_CHAIN}/${ROUTE_KEYS.QUESTIONNAIRES}/:questionnaireResponseId`, element: <Navigate replace to="/404" /> },
   {
      path: `${ROUTE_KEYS.SUPPLY_CHAIN}/${ROUTE_KEYS.OWN_BUSINESS_AREA}/:activeSubTab?`,
      element: (
         <ContainerWrapper sx={{ height: fullPageHeight }}>
            <SelfAssessmentPage />
         </ContainerWrapper>
      ),
   },
   {
      path: `${ROUTE_KEYS.SUPPLY_CHAIN}/:activeTab/:activeSubTab?`,
      element: (
         <ContainerWrapper sx={{ height: fullPageHeight }}>
            <Dashboard />
         </ContainerWrapper>
      ),
   },

   {
      path: '/supplychain/suppliers/:supplierId/questionnaires/:dispatchId',
      element: (
         <ContainerWrapper>
            <SupplierQuestionnaireDetails />
         </ContainerWrapper>
      ),
   },

   { path: 'supplychain/suppliers/:supplierId', element: <SupplierRedirect /> },

   { path: `supplychain/suppliers/:supplierId/${ROUTE_KEYS.DOCUMENTS}`, element: <SupplierDocumentHubRedirect /> },

   {
      path: 'supplychain/suppliers/:supplierId/:activeTab/:activeSubTab?',
      element: (
         <ContainerWrapper sx={{ height: fullPageHeight }}>
            <SupplierProfileOverview />
         </ContainerWrapper>
      ),
   },
   {
      path: '/supplychain/complaints/:complaintId',
      element: (
         <ContainerWrapper>
            <ComplaintDetails />
         </ContainerWrapper>
      ),
   },
   {
      path: '/supplychain/cases/:caseId',
      element: (
         <ContainerWrapper>
            <CaseDetails />
         </ContainerWrapper>
      ),
   },
   {
      path: '/supplychain/actions/:actionId',
      element: (
         <ContainerWrapper>
            <ActionDetails />
         </ContainerWrapper>
      ),
   },
   {
      path: '/supplychain/suppliers/:supplierId/questionnaire-responses/:questionnaireResponseId',
      element: (
         <ContainerWrapper>
            <QuestionnaireResults />
         </ContainerWrapper>
      ),
   },

   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/actions/:actionId',
   //    element: <RouteRedirect params={['actionId']} to={(actionId) => getRouteNavSupplier(actionId, 'overview')} />,
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/actions/:supplierId/:activeTab',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <SupplierProfileOverview />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/suppliers',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <SuppliersList />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/suppliers/:supplierId',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <Supplier />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/suppliers/:supplierId/:activeTab',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <Supplier />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/actions',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <ActionManagement />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/actions/:taskId',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <ActionDetail />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
   // {
   //    key: 'supply-chain',
   //    path: 'supplychain/products',
   //    element: (
   //       <Container maxWidth="xl">
   //          <Suspense fallback={<FullPageLoadingIndicator />}>
   //             <ProductList />
   //          </Suspense>
   //       </Container>
   //    ),
   // },
];

export default routes;
